<template>
  <nav class="mobile-bottom-nav" aria-label="手机端主要导航">
    <RouterLink
      v-for="item in items"
      :key="item.path"
      :to="item.path"
      :class="{ 'is-active': isActive(item.path) }"
      :aria-current="isActive(item.path) ? 'page' : undefined"
    >
      <el-icon><component :is="item.icon" /></el-icon>
      <span>{{ item.label }}</span>
    </RouterLink>
  </nav>
</template>

<script setup lang="ts">
import { Bell, Checked, Files, House, List } from "@element-plus/icons-vue";
import { RouterLink, useRoute } from "vue-router";

const route = useRoute();
const items = [
  { path: "/dashboard", label: "工作台", icon: House },
  { path: "/work-items", label: "我的工作", icon: Checked },
  { path: "/projects", label: "项目", icon: Files },
  { path: "/issues", label: "问题", icon: List },
  { path: "/notifications", label: "提醒", icon: Bell },
];

function isActive(path: string) {
  return route.path === path || route.path.startsWith(`${path}/`);
}
</script>

<style scoped>
.mobile-bottom-nav {
  display: none;
}

@media (max-width: 960px) {
  .mobile-bottom-nav {
    align-items: stretch;
    background: rgba(255, 255, 255, 0.96);
    border-top: 1px solid var(--line);
    bottom: 0;
    box-shadow: 0 -8px 24px rgba(20, 40, 80, 0.09);
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    left: 0;
    padding: 5px 8px calc(5px + env(safe-area-inset-bottom));
    position: fixed;
    right: 0;
    z-index: 30;
  }

  .mobile-bottom-nav a {
    align-items: center;
    border-radius: var(--r-md);
    color: var(--t-muted);
    display: flex;
    flex-direction: column;
    font-size: 11px;
    gap: 2px;
    justify-content: center;
    min-height: 48px;
    position: relative;
  }

  .mobile-bottom-nav a::before {
    background: transparent;
    border-radius: 0 0 3px 3px;
    content: "";
    height: 3px;
    left: 26%;
    position: absolute;
    right: 26%;
    top: -5px;
  }

  .mobile-bottom-nav a.is-active {
    background: var(--brand-softer);
    color: var(--brand);
    font-weight: 700;
  }

  .mobile-bottom-nav a.is-active::before {
    background: var(--brand);
  }

  .mobile-bottom-nav .el-icon {
    font-size: 20px;
  }
}
</style>
